import React from 'react'
import { Block } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import { COLOR } from '../../../utils/constants/color.constants'

const UIIconButtonBlock = ({ sx, ...props }) => {
  return (
    <IconButton
      sx={{
        borderRadius: '6px',
        '&:hover': {
          '& svg': {
            fill: COLOR.RED_DARK,
          },
        },
        ...sx,
      }}
      {...props}
    >
      <Block sx={{ fill: COLOR.GRAY_MEDIUM }} />
    </IconButton>
  )
}

export default UIIconButtonBlock
